
const Banner = ({children , title , subtitle}) => {
  return (
    <div className='banner'>
      <h1>{title}</h1>
      <span className='line'></span>
      <p>{subtitle}</p>
      {children}
    </div>
  )
}

export default Banner 